import { duplicateSSRsByUOS } from './duplicateSSRsByUOS';
import { highestAssignedSSR, highestAssignedUOS } from './highestAssigned';

const needsAnSSR = (switches) =>
  (switches ?? []).some((eachSwitch) => eachSwitch?.heatingSys !== 'tgs');

export const collectConfirmProblems = ({
  locationName,
  civicAddress,
  numOfUOS,
  numOfSSR,
  numSwitches,
  switches,
}) => {
  const problems = [];

  if (!/^.*-.*-.*$/.test(locationName ?? '')) {
    problems.push('location name needs 2 dashes — e.g. ACME-MAIN STREET-MST');
  }

  if (!civicAddress) {
    problems.push('civic address is empty');
  }

  const uosCount = Number(numOfUOS);
  const ssrCount = Number(numOfSSR);
  const switchCount = Number(numSwitches);

  if (uosCount === 0) {
    problems.push('number of uos panels is 0');
  } else if (!Number.isInteger(uosCount) || uosCount < 0) {
    problems.push('number of uos panels must be a positive whole number');
  }

  if (!Number.isInteger(ssrCount) || ssrCount < 0) {
    problems.push('ssr qty. must be a non-negative whole number');
  } else if (ssrCount === 0 && needsAnSSR(switches)) {
    problems.push('ssr qty. is 0');
  }

  const uosAssigned = highestAssignedUOS(switches);
  if (Number.isInteger(uosCount) && uosCount > 0 && uosAssigned > uosCount) {
    problems.push(
      `uos ${String(uosAssigned).padStart(
        2,
        '0',
      )} is assigned but there are only ${uosCount} uos panels`,
    );
  }

  const ssrAssigned = highestAssignedSSR(switches);
  if (Number.isInteger(ssrCount) && ssrCount > 0 && ssrAssigned > ssrCount) {
    problems.push(
      `ssr${ssrAssigned} is assigned but there are only ${ssrCount} ssrs`,
    );
  }

  duplicateSSRsByUOS(switches).forEach(({ UOS, ssrs }) => {
    problems.push(
      `uos ${UOS} — ${ssrs.join(', ')} assigned to more than one switch`,
    );
  });

  if (switchCount === 0) {
    problems.push('number of switches is 0');
  } else if (!Number.isInteger(switchCount) || switchCount < 0) {
    problems.push('number of switches must be a positive whole number');
  }

  const unassigned = (switches ?? [])
    .map((eachSwitch, idx) => (eachSwitch.UOS ? null : idx + 1))
    .filter(Boolean);

  if (unassigned.length > 0) {
    const label = unassigned.length === 1 ? 'switch' : 'switches';
    problems.push(`${label} ${unassigned.join(', ')} — no UOS assigned`);
  }

  return problems;
};
